import Dexie from 'dexie';
import { IAnimal } from '../DexieDB/modules/animals/entities/IAnimal';

type Table = Dexie.Table<IAnimal, any>;

type Data = {
  animalTable: Table;
  animal: IAnimal;
};

export async function VerificarDadosDoAnimal({ animalTable, animal }: Data) {
  if (animal.numero_de_identificacao) {
    const existePorNum = await animalTable
      .where('numero_de_identificacao')
      .equals(animal.numero_de_identificacao)
      .toArray();

    if (existePorNum.length !== 0) {
      throw new Error('Já existe um animal com esse número de identificação!');
    }
  } else if (animal.bottom_eletronico) {
    const existeBotom = await animalTable
      .where('bottom_eletronico')
      .equals(animal.bottom_eletronico)
      .toArray();

    if (existeBotom.length !== 0) {
      throw new Error('Já existe um animal com esse botom eletrônico!');
    }
  }
}
